$(function() {
  
  $(document).scroll(function() {
    var screen = $(window);

    //add visible class to .fade-up & .intro-mock elements when they're inside the viewport
    if (screen.width() > 768) {
      $('.js-fade').each(function() {
        if ($(this).visible(true)) {
            var halfWindow = ($(window).height() / 1.5);
            var elemP = $(this).offset().top; //get the offset top of the element
            var dist = elemP - $(window).scrollTop();
            
  
            if (dist < halfWindow) {
              $(this).addClass('visible');
            }
  
         } 

      });
    }


    //adds class .visible if swiper carousel is in viewport
    $('.c-casehistory__scroll').each(function()  {
      
      if ($(this).visible(true)) {
        $('.c-casehistory__scroll-story').addClass('visible');          
       } else {
        $('.c-casehistory__scroll-story').removeClass('visible');
       }
    });

    $('.fx-anim-under').each(function()  {
      if ($(this).visible(true)) {
        $(this).delay(1000).addClass('visible');       
       } else {
        $(this).removeClass('visible');
        $(this).removeClass('delayed');  
       }
    });

    
    //start and stop swiper carousel if it has or not .visible class
    if($('.js-swiper-soisy').length) {

      var mySwiper = document.querySelector('.js-swiper-soisy').swiper;

      $('.c-casehistory__scroll-story').each(function()  {
        
        if (!$(this).hasClass('visible')) {
          mySwiper.stopAutoplay();   
        } else {
          mySwiper.startAutoplay(); 
        }  
      });    

    }

  });


});

